import React from 'react';
import { Button, Image, Divider } from 'semantic-ui-react';
import PromotionCode from '../PromotionCode';
import '../custom-theme.css';
var REACT_APP_ACCOUNT_API_IMAGE_PATH = process.env.REACT_APP_ACCOUNT_API_IMAGE_PATH;
var ChoosePaymentMethod = function ChoosePaymentMethod(_ref) {
  var user = _ref.user,
    onPaymentMethodClick = _ref.onPaymentMethodClick,
    showPromoCode = _ref.showPromoCode,
    defaultPromoCode = _ref.defaultPromoCode,
    onValidatedPromoCode = _ref.onValidatedPromoCode,
    onInvalidPromoCode = _ref.onInvalidPromoCode,
    darkMode = _ref.darkMode,
    loadUser = _ref.loadUser,
    context = _ref.context;
  var buttonStyle = {
    textAlign: 'left',
    borderStyle: 'solid'
  };
  if (!darkMode) {
    Object.assign(buttonStyle, {
      borderColor: 'lightgray',
      backgroundColor: '#fff'
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "choosePaymentMethod"
  }, /*#__PURE__*/React.createElement(Button, {
    fluid: true,
    onClick: function onClick() {
      return onPaymentMethodClick('card');
    },
    style: buttonStyle
  }, /*#__PURE__*/React.createElement("div", null, "Credit or Debit Card"), /*#__PURE__*/React.createElement(Image, {
    inline: true,
    src: "".concat(REACT_APP_ACCOUNT_API_IMAGE_PATH, "/visa.png")
  }), "\xA0\xA0", /*#__PURE__*/React.createElement(Image, {
    inline: true,
    src: "".concat(REACT_APP_ACCOUNT_API_IMAGE_PATH, "/mastercard").concat(darkMode ? '-dark-mode' : '', ".png")
  }), "\xA0\xA0", /*#__PURE__*/React.createElement(Image, {
    inline: true,
    src: "".concat(REACT_APP_ACCOUNT_API_IMAGE_PATH, "/americanexpress.png")
  }), "\xA0\xA0", /*#__PURE__*/React.createElement(Image, {
    inline: true,
    src: "".concat(REACT_APP_ACCOUNT_API_IMAGE_PATH, "/discover.png")
  }), "\xA0\xA0", /*#__PURE__*/React.createElement(Image, {
    src: "".concat(REACT_APP_ACCOUNT_API_IMAGE_PATH, "/chevron.svg"),
    style: {
      float: 'right',
      height: '19px',
      marginTop: '4px'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      height: '5px'
    }
  }), /*#__PURE__*/React.createElement(Button, {
    fluid: true,
    onClick: function onClick() {
      return onPaymentMethodClick('paypal');
    },
    style: buttonStyle
  }, /*#__PURE__*/React.createElement("div", null, "PayPal"), /*#__PURE__*/React.createElement(Image, {
    src: "".concat(REACT_APP_ACCOUNT_API_IMAGE_PATH, "/paypal").concat(darkMode ? '-dark-mode' : '', ".png"),
    inline: true,
    style: darkMode ? {} : {
      marginTop: '3px'
    }
  }), "\xA0\xA0", /*#__PURE__*/React.createElement(Image, {
    src: "".concat(REACT_APP_ACCOUNT_API_IMAGE_PATH, "/chevron.svg"),
    style: {
      float: 'right',
      height: '19px',
      marginTop: '2px'
    }
  })), showPromoCode && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(PromotionCode, {
    user: user,
    defaultPromoCode: defaultPromoCode,
    onValidatedPromoCode: onValidatedPromoCode,
    onInvalidPromoCode: onInvalidPromoCode,
    darkMode: darkMode,
    loadUser: loadUser,
    context: context
  })));
};
ChoosePaymentMethod.defaultProps = {
  darkMode: false
};
export default ChoosePaymentMethod;